
import { validatenull } from './validate';
/**
 * 小数四舍五入
 * @param {*} val 
 * @param {*} len 
 */
export function getFixed (val = 0, len = 2) {
    return Number(val.toFixed(len));
  }
  
  
/**
 * 获取像素设置值
 * @param {*} val 
 * @param {*} defval 
 */
export const getPx = (val, defval = '') => {
    if (validatenull(val)) val = defval;
    if (validatenull(val)) return '';
    val = val + '';
    if (val.indexOf('%') === -1) {
        val = val + 'px';
    }
    return val;
}



export const toDecimal =  (x) => {
    var f = parseFloat(x)
    if (isNaN(f)) {
        return 0
    }
    f = Math.round(x * 100) / 100
    return f
}


export const countFileSize = (size) => {
    var m_strSize = ""
    var factSize = 0
    factSize = size
    if (factSize < 1024.00)
        m_strSize = toDecimal(factSize) + " B";
    else if (factSize >= 1024.00 && factSize < 1048576)
        m_strSize = toDecimal(factSize / 1024.00) + " KB";
    else if (factSize >= 1048576 && factSize < 1073741824)
        m_strSize = toDecimal(factSize / 1024.00 / 1024.00) + " MB";
    else if (factSize >= 1073741824)
        m_strSize = toDecimal(factSize / 1024.00 / 1024.00 / 1024.00) + " GB";
    return m_strSize;
  }

